import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  const colorMap: Record<string, string> = {
    accent: 'bg-accent-100/80 text-accent-700 group-hover:bg-accent-200/80',
    primary: 'bg-primary-100/70 text-primary-700 group-hover:bg-primary-200/70',
    secondary: 'bg-secondary-100/80 text-secondary-700 group-hover:bg-secondary-200/80',
  };

  const iconBgMap: Record<string, string> = {
    accent: 'bg-accent-500',
    primary: 'bg-primary-500',
    secondary: 'bg-secondary-500',
  };

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            探索攻略分类
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            按照您感兴趣的主题浏览内容，从角色背景到实战技巧，应有尽有
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center text-center p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300/60 transition-all duration-300"
            >
              <div className={`w-14 h-14 flex items-center justify-center rounded-xl ${iconBgMap[cat.color] || 'bg-primary-500'} text-background-50 mb-4`}>
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-2">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}